import { useEffect } from "react";

import { resetVehicleAssignmentStores } from "@/lib/cat/reset-vehicle-assignment-stores";
import { useCurrentDraftStore } from "@/stores/selected-vehicle-store";
import { useDraftResumeStore } from "@/stores/draft-resume-store";
import { releaseDraftLockAction } from "@/app/lib/actions/cat/draft-lock-heartbeat";

export function useVehicleAssignmentFlowCleanup() {
  useEffect(() => {
    return () => {
      const draftId = useCurrentDraftStore.getState().currentDraft?.id;
      if (draftId) {
        void releaseDraftLockAction({ draftId });
      }
      useDraftResumeStore.getState().clearInconsistencies();
      resetVehicleAssignmentStores();
    };
  }, []);
}
